module.exports = __webpack_public_path__ + "static/media/ba.8c3abbf7.svg";